import React from 'react'

const DayPickerSingleContext = React.createContext()

export default DayPickerSingleContext
